// Rail des gammes d'une fiche produit : flèches précédent / suivant, trait de progression et
// glisser à la souris (Ingrid, 04/10 : à la souris sur PC, rien ne permettait d'aller vers la
// droite). Flèches et trait ne s'affichent que si le rail déborde ; le tactile, le trackpad et
// Maj + molette défilent nativement. L'accueil garde son propre rail (accueil-anima.js).

const DRAG_THRESHOLD = 5 // px avant de considérer qu'on tire le rail
const EDGE = 2 // px de tolérance aux extrémités
const DECIMALES = 4 // des variables CSS de progression
const reduit = window.matchMedia('(prefers-reduced-motion: reduce)')

const glisserSouris = (rail) => {
  let startX = 0
  let startScroll = 0
  let dragging = false
  let moved = false

  rail.addEventListener('pointerdown', (e) => {
    if (e.pointerType !== 'mouse') {
      return
    }
    dragging = true
    moved = false
    startX = e.clientX
    startScroll = rail.scrollLeft
  })
  rail.addEventListener('pointermove', (e) => {
    if (!dragging) {
      return
    }
    const dx = e.clientX - startX
    if (Math.abs(dx) > DRAG_THRESHOLD) {
      moved = true
      rail.classList.add('is-dragging')
    }
    if (moved) {
      rail.scrollLeft = startScroll - dx
    }
  })
  const stop = () => {
    dragging = false
    rail.classList.remove('is-dragging')
  }
  rail.addEventListener('pointerup', stop)
  rail.addEventListener('pointerleave', stop)
  // Un glisser ne doit pas ouvrir la carte sous le pointeur.
  rail.addEventListener('click', (e) => {
    if (moved) {
      e.preventDefault()
      moved = false
    }
  }, true)
  rail.addEventListener('dragstart', (e) => e.preventDefault())
}

const initNav = (nav) => {
  const rail = document.getElementById(nav.dataset.animaRailNav)
  const prev = nav.querySelector('[data-anima-rail-prev]')
  const next = nav.querySelector('[data-anima-rail-next]')
  if (!rail || !prev || !next) {
    return
  }
  const progress = document.querySelector(`[data-anima-rail-progress="${rail.id}"]`)

  // Un pas = les cartes entièrement visibles (au moins une).
  const pas = () => {
    const carte = rail.firstElementChild
    const gap = parseFloat(getComputedStyle(rail).columnGap) || 0
    const w = carte ? carte.getBoundingClientRect().width + gap : rail.clientWidth

    return Math.max(1, Math.floor((rail.clientWidth + gap) / w)) * w
  }

  const maj = () => {
    const max = rail.scrollWidth - rail.clientWidth
    const deborde = max > EDGE
    nav.hidden = !deborde
    prev.disabled = rail.scrollLeft <= EDGE
    next.disabled = rail.scrollLeft >= max - EDGE
    if (progress) {
      progress.hidden = !deborde
      progress.style.setProperty('--anima-rail-vu', (rail.clientWidth / rail.scrollWidth).toFixed(DECIMALES))
      progress.style.setProperty('--anima-rail-p', (max > 0 ? rail.scrollLeft / max : 0).toFixed(DECIMALES))
    }
  }

  const aller = (sens) => rail.scrollBy({
    left: sens * pas(),
    behavior: reduit.matches ? 'auto' : 'smooth'
  })
  prev.addEventListener('click', () => aller(-1))
  next.addEventListener('click', () => aller(1))

  let frame = 0
  rail.addEventListener('scroll', () => {
    if (!frame) {
      frame = requestAnimationFrame(() => {
        frame = 0
        maj()
      })
    }
  }, {
    passive: true
  })
  new ResizeObserver(maj).observe(rail)
  glisserSouris(rail)
  maj()
}

const init = () => {
  document.querySelectorAll('[data-anima-rail-nav]').forEach(initNav)
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init)
} else {
  init()
}
